import React, {useCallback} from 'react';
import classNames from 'classnames';

const CurrencySwitchItem = ({value, label, active, setCurrency}) => {
    const handleClick = useCallback(() => setCurrency(value), [value, setCurrency]);

    return (
        <button type="button" className={classNames('currency-switch-item', {active})} onClick={handleClick}>
            {label}
        </button>
    );
};

export default CurrencySwitchItem;
